import { render, staticRenderFns } from "./SemiologiaDermatologica.vue?vue&type=template&id=1329daf0"
import script from "./SemiologiaDermatologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaDermatologica.vue?vue&type=script&lang=js"
import style0 from "./SemiologiaDermatologica.vue?vue&type=style&index=0&id=1329daf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports